import apiDB from "./api_db";
import store from "../store";
import notification from "../components/subcomponents/notification";
import connect_api from "../connect/connect_api";

class raceAPI extends apiDB {
  events_list() {
    connect_api.sPOST(
      "/" + this.api_module + "/events_list",
      {},
      function (error, response) {
        if (error) {
          notification.error(error.message);
        } else {
          store.dispatch({
            type: "RACE_EVENTS_LIST",
            data: response.api_data,
          });
        }
      }
    );
  }

  event_details() {
    const state = store.getState();
    //policy_id:state.policyR.policy.selected
    connect_api.sPOST(
      "/" + this.api_module + "/event_details",
      { controller_id: state.raceR.events.selected },
      function (error, response) {
        if (error) {
          notification.error(error.message);
        } else {
          store.dispatch({
            type: "RACE_EVENT_DETAILS",
            data: response.api_data,
          });
        }
      }
    );
  }

  save_race() {
    const state = store.getState();
    connect_api.sPOST(
      "/" + this.api_module + "/save_race",
      { controller_id: state.raceR.events.selected },
      function (error, response) {
        if (error) {
          notification.error(error.message);
        } else {
          notification.success("Race saved");
        }
      }
    );
  }
  get_branding(callback) {
    const state = store.getState();
    connect_api.sPOST(
      "/" + this.api_module + "/get_branding",
      { controller_id: state.raceR.events.selected },
      function (error, response) {
        // loaded on mount, so stay quiet when the controller has no event yet
        if (error) {
          callback(null);
        } else {
          callback(response.api_data.branding);
        }
      }
    );
  }

  save_branding(branding, callback) {
    const state = store.getState();
    connect_api.sPOST(
      "/" + this.api_module + "/save_branding",
      {
        controller_id: state.raceR.events.selected,
        branding: branding,
      },
      function (error, response) {
        if (error) {
          notification.error(error.message);
        } else {
          notification.success("Event branding saved");
          callback(response.api_data.branding);
        }
      }
    );
  }

  set_race_type(race_type_id) {
    const state = store.getState();
    connect_api.sPOST(
      "/" + this.api_module + "/set_race_type",
      {
        controller_id: state.raceR.events.selected,
        race_type_id: race_type_id,
      },
      function (error, response) {}
    );
  }
  set_company(company_id) {
    const state = store.getState();
    connect_api.sPOST(
      "/" + this.api_module + "/set_company",
      {
        controller_id: state.raceR.events.selected,
        company_id: company_id,
      },
      function (error, response) {}
    );
  }
  set_championship(championship) {
    const state = store.getState();
    connect_api.sPOST(
      "/" + this.api_module + "/set_championship",
      {
        controller_id: state.raceR.events.selected,
        championship: championship,
      },
      function (error, response) {}
    );
  }
}

let race = new raceAPI({
  api_module: "race_current",
  table_key_name: "id",
  reducer_name: "raceR",
  reducer_var: "race_current",
  action_prefix: "RACE",
});

export default race;
